/** Atributo em backdrops de modal — permite cleanup de overlays órfãos. */
export const EAMB_OVERLAY_ATTR = 'data-eamb-overlay';

const BODY_LOCK_CLASS = 'eamb-modal-open';

/** Remove scroll lock aplicado por modais. */
export function releaseBodyScrollLock(): void {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = '';
  document.body.style.pointerEvents = '';
  document.body.classList.remove(BODY_LOCK_CLASS);
}

/** Bloqueia scroll do body enquanto modal está aberto. */
export function lockBodyScroll(): void {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = 'hidden';
  document.body.classList.add(BODY_LOCK_CLASS);
}

/** Remove backdrops órfãos (ex.: após troca CLIENT → OWNER). */
export function removeOrphanOverlays(): void {
  if (typeof document === 'undefined') return;
  document.querySelectorAll(`[${EAMB_OVERLAY_ATTR}]`).forEach((el) => {
    el.remove();
  });
  releaseBodyScrollLock();
}

export function isDashboardRole(role: string): boolean {
  return ['OWNER', 'VENDOR', 'DRIVER', 'SUPPLIER', 'CITY_HALL'].includes(role);
}
